import React, { memo } from 'react';
import { View } from 'react-native';
const HeaderPartnerBase = ({ widgetItem, renderItem }) => {
    return (React.createElement(View, { style: {
            paddingHorizontal: 16,
            flex: 1,
            shadowColor: '#d0d5dd',
            borderBottomColor: '#F1F3F5',
            borderBottomWidth: 1,
            shadowOffset: {
                width: 0,
                height: 1,
            },
            shadowRadius: 12,
            shadowOpacity: 0.3,
            height: 64,
        } }, !!widgetItem &&
        !!renderItem &&
        renderItem(widgetItem)));
};
export default memo(HeaderPartnerBase);
export { HeaderPartnerBase };
